import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";

interface HowManyCustomersContentProps {
    departure: string,
    destination: string,
    availableTransportation: string
    totalTicketsSold: number
}

function HowManyCustomersContent(props: HowManyCustomersContentProps) {
    const {
        departure,
        destination,
        availableTransportation,
        totalTicketsSold,
    } = props

    const title = useTranslation(
        `${singleModalTranslationKey}.how_many_buy.title`,
        {departure, destination, availableTransportation}
    )

    const content = useTranslation(
        `${singleModalTranslationKey}.how_many_buy.description`,
        {departure, destination, availableTransportation, totalTicketsSold}
    )

    return (
        <TitleAndContent
            title={title}
            content={content}
        />
    )
}

export default HowManyCustomersContent